import React from 'react';
import { cn } from '@/lib/utils';

export function PageHeader({ title, description, actions, className }) {
  return (
    <div className={cn('flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-6', className)}>
      <div>
        <h1 className="text-2xl font-semibold tracking-tight" data-testid="page-title">
          {title}
        </h1>
        {description && (
          <p className="text-muted-foreground mt-1" data-testid="page-description">
            {description}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2" data-testid="page-actions">
          {actions}
        </div>
      )}
    </div>
  );
}

export default PageHeader;
